export default __webpack_public_path__ + "a8f7b7a8109bc38649b1f4f5027164d1.png";